import * as z from "zod";
import { setTenantRoles } from "../rbac/validation/setTenantRoles";
import { mutator } from "./mutator";

export const setServiceAccountTenantRoles = mutator({
  schema: z.object({
    serviceAccountId: z.string(),
    builtinRoleIds: z.array(z.string()).default([]),
    customRoleIds: z.array(z.string()).default([]),
  }),
  resolve: {
    serviceAccount: { kind: "serviceAccount", from: "serviceAccountId" },
  },
  permissions: [
    {
      permission: "service_account:manage",
      scopeId: ({ args }) => args.serviceAccount.id,
    },
    { permission: "tenant:roles_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({
    tx,
    ctx,
    args: { serviceAccount, builtinRoleIds, customRoleIds },
  }) => {
    await setTenantRoles(
      tx,
      { serviceAccountId: serviceAccount.id },
      builtinRoleIds,
      customRoleIds,
      ctx.tenantId,
      ctx
    );
  },
});
